export enum QCReportFilter {
    ALL_REPORTS = "ALL_REPORTS",
    ALL_FAILED = "ALL_FAILED",
    ALL_TRASHED = "ALL_TRASHED",
    NOT_DECIDED = "NOT_DECIDED",
    ALL_1QC_REPORTS = "ALL_1QC_REPORTS",

}
export interface Report {
    sangerPlateReport: SangerPlateReport;
}
export interface SangerPlateReport {
    ReportIdenfifier: string;
    ReportDate: Date;
    ReportTime: string;
    ReportType: string;
    PlateName: string;
    PlateQCStatus: string;
    PlateQCComment: string;
    Instrument: Instrument;
    Container: Container;
    PlateQCStatistics: PlateQCStatistics;
    Run: Run;
    Reads: Reads;
}

export interface Container {
    ContainerIdentifier: string;
    ContainerName: string;
    ContainerOwner: string;
    PlateType: string;
    PlateSize: string;
    // PlateSize:number;
}

export interface Instrument {
    InstrumentNameAndSerialNumber: string;
    OfficialInstrumentName: string;
    NumCapillaries: string;
    //NumCapillaries: number;
}

export interface PlateQCStatistics {
    ReadFiles: ReadFiles;
    EurofinsControls: EurofinsControls;
    BaseCallStart: AvgSignalIntensity;
    AvgSignalIntensity: AvgSignalIntensity;
    DyeBlobs: DyeBlobs;
    QV20contiguousReads: QV20ContiguousReads;
    MixedSeq: DyeBlobs;
    MissingSeq: DyeBlobs;
}

export interface AvgSignalIntensity {
    Beg: string;
    End: string;
    NumberFailed: string;
    PercentageFailed: number;
    // Beg: number;
    // End: number;
    // NumberFailed: number;
    // PercentageFailed: string;
}

export interface DyeBlobs {
    NumberFailed: string;
    PercentageFailed: string;
    // NumberFailed: number;
    // PercentageFailed: number;
}

export interface EurofinsControls {
    Number: string;
    NumberCorrect: string;
    NumberIncorrect: string;
    NumberUnassigned: string;
    // Number: number;
    // NumberCorrect: number;
    // NumberIncorrect: number;
    // NumberUnassigned: number;
}

export interface QV20ContiguousReads {
    Cutoff: string;
    NumberFailed: string;
    PercentageFailed: string;
    // Cutoff: number;
    // NumberFailed: number;
    // PercentageFailed: number;
}

export interface ReadFiles {
    NumberFiles: string;
    NumberFilesUsed: string;
    NumberFilesEmpty: string;
    // NumberFiles: number;
    // NumberFilesUsed: number;
    // NumberFilesEmpty: number;
}

export interface Reads {
    Read: Read[];
}

export interface Read {
    WellId: string;
    SampleName: string;
    SampleScore: string;
    // SampleScore: number;
    Comment: string;
    OrderID: OrderID;
    IsEurofinsControl?: IsEurofinsControl;
    IsEmpty: string;
    // IsEmpty: number;
    IsPeaktraced: string;//number

    Sequence: string;
    SequenceLength: string;//number
    ClearRangeLength: string;//number
    ClearRangeBeg: string;//number
    ClearRangeEnd: string;//number
    ContiguousReadLength: string;//number
    ContiguousReadBeg: string;//number
    ContiguousReadEnd: string;//number
    BasecallerName: BasecallerName;
    BasecallerVersion: BasecallerVersion;
    RunProtocolName: RunProtocolName;
    RunProtocolVersion: string;//number
    AnalysisProtocolName: AnalysisProtocolName;
    AnalysisProtocolVersion: string;//number
    BasecallDateTime: string;
    BasecallStart: string;//number
    BasecallStop: string;//number
    CapillaryNumber: string;//number
    Peak1Location: string;//number
    PeakAreaRatio: string;//number
    AvgPeakSpacing: string;//number
    AvgNoiseAllDyes: string;//number
    AvgSignalAllDyes: string;//number
    AvgSignalToNoiseRatio: string;//number
    RawQualityAverage: string;//number
    RawQualityMin: string;//number
    RawQualityMax: string;//number
    ClearQualityAverage: string;//number
    ClearQualityMin: string;//number
    ClearQualityMax: string;//number
    NumLowQualityBasesQV19: string;//number
    NumHighQualityBasesQV20: string;//number
}

export enum AnalysisProtocolName {
    Mvr = "MVR",
}

export enum BasecallerName {
    KB = "KB",
}

export enum BasecallerVersion {
    The1418 = "1.4.1.8",
}

export interface IsEurofinsControl {
    ControlIdentifier: string;
    ReadIdentifier: string;
    ReferenceName: string;
    UsedPrimer: string;
    GuessPrimer: string;
    GuessPrimerBindingSite: string;
    PositionsOnReference: string;
    LengthOfControl: string;
    Status: string;
}

export enum OrderID {
    Undef = "undef",
}

export enum RunProtocolName {
    SerLr30 = "SER_LR30",
}

export interface Run {
    RunName: string;
    RunModuleName: string;
    RunModuleVersion: string;//number
    RunStartDate: Date;
    RunStartTime: string;
    RunStopDate: Date;
    RunStopTime: string;
    ElectrophoresisVoltage: string;//number
    InjectionTime: string;//number
    InjectionVoltage: string;//number
    Chem: string;
    DyeSetName: string;
    DyeType: string;
    GelType: string;
    PolymerLotNumber: string;//number
    PolymerExpirationDate: string;
    ScanningRate: string;//number
    NumScans: string;//number
    BasecallerBcpDll: string;
    BasecallerVersion: string;
}
